var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value && !_vm.fieldOptions.hidden)?_c('v-btn',{staticStyle:{"margin":"0"},attrs:{"text":"","href":_vm.url,"target":"_blank","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fingerprint")]),_vm._v(" "+_vm._s(_vm.$t('fingerPrint.fingerBtn'))+" ")],1):_c('v-icon',[_vm._v("fingerprint")])
}
var staticRenderFns = []

export { render, staticRenderFns }